import { replaceTokens } from '@components/Utility/index.js';
export class RecordStore {
    constructor(initialRecords) {
        this._records = {};
        if (initialRecords) {
            this._records = initialRecords;
        }
    }
    replaceTokens(template, tokenValues, options = {}) {
        return replaceTokens(template, tokenValues, { records: this._records, ...options });
    }
    recordsGet() {
        return this._records;
    }
    recordGet(key) {
        return this._records[key];
    }
}
